import { render, staticRenderFns } from "./Cavity.vue?vue&type=template&id=e40aa340&scoped=true&"
import script from "./Cavity.vue?vue&type=script&lang=js&"
export * from "./Cavity.vue?vue&type=script&lang=js&"
import style0 from "./Cavity.vue?vue&type=style&index=0&id=e40aa340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40aa340",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCheckbox})
